!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t(require("react"), require("ati-ui-react/components/icons/Icon")) : "function" == typeof define && define.amd ? define("ati-ui-react", ["react", "ati-ui-react/components/icons/Icon"], t) : "object" == typeof exports ? exports["ati-ui-react"] = t(require("react"), require("ati-ui-react/components/icons/Icon")) : e["ati-ui-react"] = t(e.React, e[void 0]);
}(this, function (n, r) {
  return c = {}, o.m = i = {
    0: function (e, t) {
      e.exports = n;
    },
    1: function (e, t) {
      e.exports = r;
    },
    801: function (e, t, n) {
      "use strict";

      n.r(t), n.d(t, "default", function () {
        return o;
      });
      var t = n(0),
        r = n.n(t),
        t = n(1),
        n = n.n(t),
        t = function () {
          return r.a.createElement("g", {
            fill: "none"
          }, r.a.createElement("path", {
            fill: "#141414",
            d: "M0 4.93v2.021l5.48-.6V4.164L0 4.93m1.749 2.144V14h2.006V6.87l-2.006.204M6.22 4.06V14h2.114V3.765L6.22 4.06m2.508-.35v2.286l3.053-.334v-2.38l-3.053.428m0 3.988v2.328l2.004-.109v-2.39l-2.004.17m0 4.007V14h3.053v-2.387l-3.053.091m10.948-9.529V14h2.772V1.788l-2.772.387m3.29-.46v2.72l4.039-.442V1.15l-4.04.565m0 4.766v2.77l2.648-.144V6.255l-2.648.226m0 4.795V14h4.04v-2.845l-4.04.121M12.59 3.17V14h2.408V2.833l-2.408.337m2.858 8.333V14h3.495v-2.602l-3.495.105M36.06 1.017c-.876-.824-2.16-1.161-3.565-.96v3.016c.569-.031 1.03.179 1.235.602.325.666-.01 1.667-.8 2.594-1.218 1.43-4.457 4.357-4.457 4.357l4.65-.152c2.842-2.762 3.862-4.438 4.045-6.53a3.567 3.567 0 0 0-1.108-2.927M37.333 14v-3.157l-9.432.283m0 0V14h9.432M31.953.124c-2.74.58-4.085 2.586-3.93 5.86l2.922-.259c-.133-1.849.435-2.287 1.01-2.529L31.954.124"
          }));
        };
      t.svg = {
        viewBox: "0 0 38 14"
      };
      var o = n()(t);
    }
  }, o.c = c, o.d = function (e, t, n) {
    o.o(e, t) || Object.defineProperty(e, t, {
      enumerable: !0,
      get: n
    });
  }, o.r = function (e) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  }, o.t = function (t, e) {
    if (1 & e && (t = o(t)), 8 & e) return t;
    if (4 & e && "object" == typeof t && t && t.__esModule) return t;
    var n = Object.create(null);
    if (o.r(n), Object.defineProperty(n, "default", {
      enumerable: !0,
      value: t
    }), 2 & e && "string" != typeof t) for (var r in t) o.d(n, r, function (e) {
      return t[e];
    }.bind(null, r));
    return n;
  }, o.n = function (e) {
    var t = e && e.__esModule ? function () {
      return e.default;
    } : function () {
      return e;
    };
    return o.d(t, "a", t), t;
  }, o.o = function (e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
  }, o.p = "", o(o.s = 801);
  function o(e) {
    if (c[e]) return c[e].exports;
    var t = c[e] = {
      i: e,
      l: !1,
      exports: {}
    };
    return i[e].call(t.exports, t, t.exports, o), t.l = !0, t.exports;
  }
  var i, c;
});